// Import SDK functions
import {
  fetchInbox,
  markRead,
  connectRealtime,
  notificationsSDK
} from './sdk.js';

// Export types for TypeScript users
export type {
  NotificationConfig,
  InboxItem,
  InboxResponse,
  FetchInboxOptions,
  MarkReadOptions,
  ConnectRealtimeOptions,
  WebSocketMessage
} from './types.js';

// Version info
declare const __VERSION__: string;
export const version = typeof __VERSION__ !== 'undefined' ? __VERSION__ : '1.0.0';

// Export functions for external use
export {
  fetchInbox,
  markRead,
  connectRealtime,
  notificationsSDK
};

// Initialize global object for configuration
if (typeof window !== 'undefined') {
  (window as unknown as Record<string, unknown>).AlphaLearnNotifications = {
    fetchInbox,
    markRead,
    connectRealtime,
    notificationsSDK,
    version,
  };

  console.log(`AlphaLearn Notifications SDK v${version} loaded`);
}